import React from "react";
import { Checkbox, CheckboxProps } from "@mui/material";



const BlueCheckbox = (props: CheckboxProps) => (
  <Checkbox
    sx={{
        color: "var(--kyocera-blue)",
        "&.Mui-checked": {
          color: "var(--kyocera-blue)",
        },
    }}
    color="default"
    {...props}
  />
);

export default BlueCheckbox;
